import { unauthorized } from '@/api/api-endpoints'
import * as turf from '@turf/turf'
import { COLORS } from '@/utils'
import timeHelper from '@/app/routes/utils/timeHelper'

export default {
  data() {
    return {
      circleLayer: null,
      complaints: [],
      filteredComplaints: [],
      showAnalizComplaint: false,
      options: [
        {
          id: 'last-week',
          filter: 'getLastWeek',
          name: 'За последнюю неделю',
        },
        {
          id: 'last-month',
          filter: 'getLastMonth',
          name: 'За последний месяц',
        },
        {
          id: 'last-three-month',
          filter: 'getLastThreeMonth',
          name: 'За последние 3 месяца',
        },
        {
          id: 'last-year',
          filter: 'getLastYear',
          name: 'За последний год',
        },
        {
          id: 'all',
          name: 'За всё время',
        },
      ],
      fields: {
        date: ['all'],
      },
    }
  },
  computed: {
    radius() {
      const zoom = this.$route.query.zoom
      const MAX_ZOOM_TO_ADJUST = 11
      const MIN_ZOOM_TO_ADJUST = 6
      const zooms = {
        11: 1,
        10: 1.5,
        9: 2,
        8: 2.5,
        7: 6,
        6: 9,
      }
      let number
      if (zoom > MAX_ZOOM_TO_ADJUST) {
        number = 1
      }
      if (zoom < MIN_ZOOM_TO_ADJUST) {
        number = (100 / zoom).toFixed(2)
      }
      if (!number) {
        number = zooms[zoom]
      }

      return 1000 * number
    },
  },
  watch: {
    radius: function () {
      this.drawComplaints()
    },
  },
  mounted() {
    if (this.hasAnalyzeComplaint) {
      this.getComplaints()
    }
  },
  methods: {
    changeAnalizComplaintSwitch() {
      if (this.showAnalizComplaint) {
        this.drawComplaints()
      } else {
        this.circleLayer.clearLayers()
      }
    },
    drawComplaints() {
      if (!this.showAnalizComplaint) {
        return
      }
      const objects = []
      this.circleLayer.clearLayers()

      if (!this.fields.date.length) {
        return
      }

      this.filteredComplaints.forEach((item) => {
        const coordinates = JSON.parse(item.geo_json_circle).coordinates
        let isIntersect = false
        let count = 0

        this.filteredComplaints.forEach((other) => {
          const otherCoordinates = JSON.parse(other.geo_json_circle).coordinates

          isIntersect = turf.booleanIntersects(
            turf.polygon(coordinates),
            turf.polygon(otherCoordinates)
          )
          if (isIntersect) count++
        })
        objects.push({
          ...item,
          coordinates,
          count,
        })
      })
      objects.forEach((item) => {
        let color = '#3af302'
        if (item.count === 2) {
          color = COLORS.yellow
        }
        if (item.count > 2) {
          color = COLORS.red
        }
        const getGeoJson = L.circle([item.latitude, item.longitude], {
          color,
          radius: this.radius,
          fillColor: color,
          weight: 1,
        })
        this.circleLayer.addLayer(getGeoJson)
      })

      if (objects.length > 0) {
        this.map.addLayer(this.circleLayer)
      } else {
        this.map.removeLayer(this.circleLayer)
      }
    },
    async getComplaints() {
      this.complaints = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: unauthorized.complaint({ query: { 'per-page': -1 } }),
        })
      ).data.data
      this.filteredComplaints = [...this.complaints]
      this.circleLayer = L.featureGroup()
    },
    changeDate(e) {
      this.fields.date = []
      if (e.target.checked) {
        this.fields.date = [e.target.value]
      }
      const complaints = [...this.complaints]
      this.options.forEach((item) => {
        if (e.target.value === item.id && item.filter) {
          this.filteredComplaints = complaints.filter((el) => {
            return (
              timeHelper.getMomentDate(el.created_at) >=
              timeHelper[item.filter]()
            )
          })
        }
      })
      if (!this.fields.date.length || e.target.value === 'all') {
        this.fields.date = ['all']
        this.filteredComplaints = [...this.complaints]
      }
      this.drawComplaints()
    },
  },
}
